var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5951 0.835938H1.40755C1.21762 0.835938 1.03546 0.911389 0.90116 1.04569C0.766857 1.18 0.691406 1.36215 0.691406 1.55208V13.7266C0.691406 14.1064 0.842308 14.4707 1.11091 14.7393C1.37952 15.008 1.74383 15.1589 2.1237 15.1589H17.8789C18.2588 15.1589 18.6231 15.008 18.8917 14.7393C19.1603 14.4707 19.3112 14.1064 19.3112 13.7266V1.55208C19.3112 1.36215 19.2357 1.18 19.1014 1.04569C18.9671 0.911389 18.785 0.835938 18.5951 0.835938ZM16.7537 2.26823L10.0013 8.45841L3.24894 2.26823H16.7537ZM17.8789 13.7266H2.1237V3.18042L9.51701 9.95785C9.64913 10.0791 9.82195 10.1464 10.0013 10.1464C10.1807 10.1464 10.3535 10.0791 10.4856 9.95785L17.8789 3.18042V13.7266Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.183333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEmail);
export default __webpack_public_path__ + "static/media/social-email.0fa4a35977689924bcbf8c7aac2e6a29.svg";
export { ForwardRef as ReactComponent };